"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateStageRoles = exports.WORKFLOVE_STATUS = exports.TRANSTION_TYPES = void 0;
var WORKFLOVE_STATUS = exports.WORKFLOVE_STATUS = ['NEW', 'AVAILABLE', 'DISABLED'];
var TRANSTION_TYPES = exports.TRANSTION_TYPES = ['SINGLE', 'ADVANCED'];
var calculateStageRoles = exports.calculateStageRoles = function calculateStageRoles(stages, actors, workflowTemplate) {
  if (!workflowTemplate.template) return [];
  var stageIds = (stages === null || stages === void 0 ? void 0 : stages.items.filter(function (el) {
    return el.available_for_template;
  }).map(function (el) {
    return el.id;
  })) || [];
  var filtered = (stages === null || stages === void 0 ? void 0 : stages.items.filter(function (stage) {
    return stageIds.findIndex(function (el) {
      return el === stage.id;
    }) >= 0;
  })) || [];
  return filtered.map(function (stage) {
    var actorFields = actors === null || actors === void 0 ? void 0 : actors.items.map(function (actor) {
      var _a;
      var fields = (_a = workflowTemplate.template) === null || _a === void 0 ? void 0 : _a.fields.map(function (field) {
        var _a, _b;
        var stageActors = (_b = (_a = workflowTemplate.stage_actors) === null || _a === void 0 ? void 0 : _a.filter(function (el) {
          return el.stage_id === stage.id;
        })) !== null && _b !== void 0 ? _b : [];
        var current = stageActors.flatMap(function (el) {
          return el.actors;
        }).filter(function (el) {
          return el.actor_id === actor.id;
        }).flatMap(function (el) {
          return el.fields;
        }).find(function (el) {
          return el.field_id === field.id;
        });
        if (current) {
          return Object.assign(Object.assign({}, current), {
            _field_name: field.name,
            _field_description: field.description
          });
        }
        return {
          field_id: field.id || '-',
          _field_name: field.name,
          _field_description: field.description,
          read: false,
          write: false,
          required: false
        };
      });
      var checked = false;
      if (fields && fields.length > 0) {
        checked = fields.filter(function (el) {
          return el.read && el.write && el.required;
        }).length === fields.length;
      }
      return {
        actor_id: actor.id,
        _actor_name: actor.name,
        _checked: checked,
        fields: fields || []
      };
    });
    return {
      stage_id: stage.id,
      _stage_name: stage.name,
      _stage_external_id: stage.external_id,
      actors: actorFields || []
    };
  });
};